import { takeLatest, put, all, call } from 'redux-saga/effects';

import BranchSummaryReportTypes from './branch-summary-report.types';
import { getBranchSummaryReportDetails } from './branch-summary-report.service';
import {
	fetchBranchSummaryReportSuccess,
	fetchBranchSummaryReportFailure,
	fetchBranchSummaryReportResponseResetChanged,
} from './branch-summary-report.action';
import { encryptData } from '../../_common/enode-decode';

/** *********************  START FETCH BranchSummary DETAILS  ******************** */
export function* fetchBranchSummaryReportDetails({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			reportDate,
			branchID,
			groupID,
			centerID,
			funderID,
			memberID,
			searchByLoanModal,
			limit,
		} = payload;
		const key = 'GetBranchSummaryReportDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			ReportDate: reportDate,
			BranchID: branchID,
			GroupID: groupID,
			CenterID: centerID,
			FunderID: funderID,
			MemberID: memberID,
			SearchByLoanModal: searchByLoanModal,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getBranchSummaryReportDetails, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchBranchSummaryReportFailure(responseData.data));
		} else {
			yield put(fetchBranchSummaryReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBranchSummaryReportFailure(error));
	}
}

export function* resetBranchSummaryReportResponse() {
	yield put(fetchBranchSummaryReportResponseResetChanged());
}

export function* onFetchBranchSummaryReportDetails() {
	yield takeLatest(
		BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_START,
		fetchBranchSummaryReportDetails,
	);
}

export function* onFetchBranchSummaryReportResponseReset() {
	yield takeLatest(
		BranchSummaryReportTypes.FETCH_BRANCH_SUMMARY_REPORT_RESPONSE_RESET_START,
		resetBranchSummaryReportResponse,
	);
}
/** *********************  END FETCH BranchSummary DETAILS ******************** */

export function* BranchSummaryReportSaga() {
	yield all([
		call(onFetchBranchSummaryReportDetails),
		call(onFetchBranchSummaryReportResponseReset),
	]);
}
